import type { PDFFeatureState } from "@/helpers/features/PDFFeature";
import type { PicturesFeatureState } from "@/helpers/features/PicturesFeature";
import type { IVideoState } from "@/interfaces";

type Item = {
  videos?: IVideoState[];
} & Partial<PDFFeatureState> &
  Partial<PicturesFeatureState>;

type State = {
  item: Item;
};

export default (state: State): Record<string, number> => {
  const counts: Record<string, number> = {};

  counts["pdf"] = (state.item.documentToUpload || []).filter(
    (item) => item.action !== "delete",
  ).length;

  counts["pictures"] = (state.item.imageList || []).filter(
    (item) => item.action !== "delete",
  ).length;

  counts["video"] = (state.item.videos || []).length;

  return counts;
};
